import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UserService, UserPayload } from "../services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { WalletsService } from "../services/wallets.service";
import { PagerserviceService } from "../services/pagerservice.service";
import csc from 'country-state-city';
import { Subscription } from "rxjs/Subscription";
import { environment } from '../../environments/environment';
import { AppCustomerService } from './appcustomer.service';
import * as moment from 'moment';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

const defaults = {
    notify: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50,
    }
}
@Component({
    selector: 'app-appcustomerlist',
    templateUrl: './appcustomerlist.component.html',
    styleUrls: ['./appcustomerlist.component.css']
})
export class AppcustomerlistComponent implements OnInit {
    favorites = new Array();
    favorite = { code: "" }
    countries: any[];
    readonlyTrue: any;
    customerList: Array<any>;
    walletsList: Array<any>;
    walletsList1 = [];
    timezonelist: Array<any>;
    walletsres: Array<any>;
    cArr: Array<any>;
    cryptoaddre = true;
    setCustomerList: {};
    //customerListById: {};
    actionListPerformed: Boolean;
    actionViewPerformed: Boolean;
    isReadOnly = true;
    showSaveRejectIcons = false;
    /* Add New customer */
    customer: Boolean;
    customersList: Boolean;
    /* Pagination fields */
    // pager Number
    pager: number;
    phonecode: any;
    // pager object
    pager1: any = {};
    Tpager: number;
    // paged items
    pagedItems: Array<any>;

    /*Filter variables*/
    serach: any;
    FilPerpage: number;
    FilPage: number;
    customerid = '';
    generatehide = false;
    filteredCustomerList = []
    /* Bank Object */
    banklist = {};
    eurbalance = 0;
    phonecodelist: Array<any>;
    walletActive: string;
    IPcountry = 'IN';
    phonenumcheck = false;
    status: string = 'Active';
    imagepath = environment.imageapiendpoint;
    currentPag: any;
    /* For Add New Customer Object */
    userobj: UserPayload = {
        _id: '',
        name: '',
        short_name: '',
        email: '',
        is_api_client: '',
        phone: null,
        password: '',
        passwordrepeat: '',
        gender: 'male',
        group: 'customer',
        _csrf: null,
        referal_code: '',
        full_phone: null,
        phonecode: 91,
        address: '',
        eurbalance: 0,
        country: '',
    };
    tfaobj = {
        _id: '',
        _csrf: '',
        tfa_status: 0
    }
    errorObj = {
        userid: '',
        name: '',
        short_name: '',
        referal_code: '',
        email: '',
        is_api_client: '',
        phone: '',
        password: '',
        passwordrepeat: '',
        group: '',
        gender: '',
        confirmpassword: '',
        phonecode: '',
        eurbalance: '',
        country: '',
        address: '',
        ask_price_spread: '',
        bid_price_spread: '',
        referal_ask_price_spread: '',
        referal_bid_price_spread: '',
    };

    passclass = 'bar';
    forgetpassObj = {
        name: '',
        target: '',
        step: '1',
        authkey: '',
        code: '',
        password: '',
        confirmpassword: '',
        phonecode: '',
        _csrf: ''
    };
    customerdetails = {};
    permission: string;
    totalRecords = 0;
    imagecheck: any;
    private subscriptions: Subscription[] = [];
    settings = {
        bigBanner: true,
        timePicker: true,
        format: 'dd-MM-yyyy',
        defaultOpen: false,
        closeOnSelect: true
    }
    public IsApiClientIds = [{ option: false }, { option: true }]
    constructor(private userService: UserService,
        private router: Router,
        private notifSer: NotificationsService,
        private spinnerService: Ng4LoadingSpinnerService,
        private walletsService: WalletsService,
        private route: ActivatedRoute,
        private pagerService: PagerserviceService,
        private appCustomerService: AppCustomerService,
        private changeDetectorRef: ChangeDetectorRef,
        private dialog: MatDialog
    ) {
        var userd = this.userService.getUserDetails();
        var userid = userd._id
    }

    public declarativeFormCaptchaValue: string;
    ngOnInit() {
        // check user is logged or not
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {

            if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
                var spt = this.router.url.split("/");
                var menu_url = spt[1];
                var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
                var adminrules = JSON.parse(localStorage.getItem('adminrules'));
                var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);

                if (index != -1) {
                    var menuid = adminmenus[index]._id;
                    var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
                    this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
                }

            }
            this.customer = false;
            this.customersList = true;
            this.customerid = this.route.snapshot.paramMap.get('id');
            this.serach = '';
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.walletActive = null;
            // this.csrf();
            this.pager = 1;
            if (typeof this.customerid != 'undefined' && this.customerid) {
                if (this.customerid) {
                    this.userService.csrf().subscribe((success) => {
                        this.userobj._csrf = success._csrf;
                    }, (err) => {
                        console.error(err);
                    })
                    this.viewData(this.customerid);
                    // this.bankDetails();
                }
            } else {
                this.router.navigateByUrl('customer');
                this.csrf();
            }
        }
        this.gettimezone();
        this.getCountry();
    }

    showCustomerForm() {
        this.customer = true;
        this.customersList = false;
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe())
    }
    csrf() {
        this.spinnerService.show();
        this.userService.csrf().subscribe((success) => {
            this.userobj._csrf = success._csrf;
            this.tfaobj._csrf = success._csrf;
            setTimeout(() => {
                this.getCustomerList();
                this.spinnerService.hide();
            }, 500);
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    handleFilterChange(event: Event): void {
        const selectedValue = (event.target as HTMLSelectElement).value;
        console.log('Selected Value:', selectedValue);
        this.status = selectedValue;
        this.getCustomerList()
    }

    hideCustomerForm() {
        this.customer = false;
        this.customersList = true;
        this.resetForm();
    }
    resetForm() {
        this.userobj.name = ''
        this.userobj.short_name = ''
        this.userobj.email = ''
        this.userobj.referal_code = ''
        this.userobj.phonecode = null
        this.userobj.phone = null
    }


    goBack() {
        this.actionListPerformed = true;
        this.actionViewPerformed = false;

        this.getCustomerList();
    }

    checkpassword(val, flag) {
        var strongRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$", "g");
        var mediumRegex = new RegExp("((^)(^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[#?!@$%^&*-]).{6,}$|^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$|^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$))+$", "g");
        if (this.MatchPassName(this.forgetpassObj.name, val)) {
            this.errorObj.password = "Do not use name in password";
        }
        if (/\s/.test(val)) {
            //    console.log("It has any kind of whitespace") 
            this.errorObj.password = 'Do not use whitespace';
        }
        if (strongRegex.test(val)) {
            this.passclass = 'strong';
        } else if (mediumRegex.test(val)) {
            this.passclass = 'medium';
        } else {
            this.passclass = 'weakasa';
            this.errorObj.password = 'Password is Weak';
        }
        if (flag === 'signup') {
            if (this.userobj.password === '') {
                this.clearError('password');
            }
        } else {
            if (this.forgetpassObj.password === '') {
                this.clearError('password');
            }
        }
    }

    clearError(field) {
        switch (field) {
            case 'userid':
                this.errorObj.userid = '';
                break;
            case 'name':
                this.errorObj.name = '';
                break;
            case 'referal_code':
                this.errorObj.referal_code = '';
                break;
            case 'is_api_client':
                this.errorObj.is_api_client = '';
                break;
            case 'short_name':
                this.errorObj.short_name = '';
                break;
            case 'email':
                this.errorObj.email = '';
                break;
            case 'phone':
                this.errorObj.phone = '';
                break;
            case 'password':
                this.errorObj.password = '';
                break;
            case 'passwordrepeat':
                this.errorObj.passwordrepeat = '';
                break;
            case 'confirmpassword':
                this.errorObj.confirmpassword = '';
                break;
            case 'group':
                this.errorObj.group = '';
                break;
            case 'eurbalance':
                this.errorObj.eurbalance = '';
                break;
            case 'country':
                this.errorObj.country = '';
                break;
            case 'ask_price_spread':
                this.errorObj.ask_price_spread = '';
                break;
            case 'bid_price_spread':
                this.errorObj.bid_price_spread = '';
                break;
            case 'referal_ask_price_spread':
                this.errorObj.referal_ask_price_spread = '';
                break;
            case 'referal_bid_price_spread':
                this.errorObj.referal_bid_price_spread = '';
                break;
        }
    }

    validateName(val) {
        if (this.MatchPassName(val, this.userobj.password)) {
            this.errorObj.name = "Do not use name in password";
        } else {
            this.clearError('name');
            this.clearError('password');
        }
    }

    MatchPassName(str, substr) {
        var lowstr = str.toLowerCase().trim();
        var lowsubstr = substr.toLowerCase();
        var lowstrArr = lowstr.split(' ');
        var PassErroArr = [];
        if (lowstr !== '' && lowsubstr !== '') {
            lowstrArr.forEach(function (item) {
                if (lowsubstr.search("^.*" + item + ".*$") > -1) {
                    PassErroArr.push(item)
                }
            })
            if (PassErroArr.length > 0) {
                return true;
            } else {
                return false;
            }
        }
    }

    matchPassword(obj) {

        if (obj.password && obj.passwordrepeat && (obj.password !== obj.passwordrepeat)) {
            this.errorObj.passwordrepeat = "Password does not match";
            return false;
        }


    }

    telInputObject(obj) {
        obj.intlTelInput('setCountry', '');
    }

    random_code(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }


    addnewUser() {
        if (this.MatchPassName(this.userobj.name, this.userobj.password)) {
            this.errorObj.password = "Do not use name in password";
            return false;
        }
        if (this.userobj.password && this.userobj.passwordrepeat && (this.userobj.password !== this.userobj.passwordrepeat)) {
            this.errorObj.passwordrepeat = "Password does not match";
            return false;
        }
        this.spinnerService.show();
        this.userService.addNewCustomer(this.userobj).subscribe((success) => {
            if (typeof this.customerid != 'undefined' && this.customerid) {
                if (this.customerid) {
                    this.viewData(this.customerid);
                }
            } else {
                if (success.status) {
                    this.notifSer.success(
                        'Success',
                        success.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                    this.hideCustomerForm();
                    setTimeout(() => {
                        this.csrf();
                        this.userobj = {
                            name: '',
                            short_name: '',
                            email: '',
                            phone: null,
                            password: '',
                            passwordrepeat: '',
                            gender: '',
                            group: 'customer',
                            _csrf: null,
                            full_phone: null,
                            eurbalance: 0,
                        };
                        this.errorObj = {
                            userid: '',
                            name: '',
                            short_name: '',
                            referal_code: '',
                            email: '',
                            is_api_client: '',
                            phone: '',
                            password: '',
                            passwordrepeat: '',
                            group: '',
                            gender: '',
                            confirmpassword: '',
                            phonecode: '',
                            eurbalance: '',
                            country: '',
                            address: '',
                            ask_price_spread: '',
                            bid_price_spread: '',
                            referal_ask_price_spread: '',
                            referal_bid_price_spread: ''
                        };
                    }, 50);
                }
                else {
                    this.notifSer.error(
                        'Error',
                        success.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                }
            }

            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            if (typeof error.error.message === 'object') {
                this.errorObj = error.error.message;
            } else {
                this.notifSer.error(
                    'Error',
                    error.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
        })
    }


    getNumber(events) {
        this.userobj.full_phone = events;
    }
    kycList: any;

    getCustomerList() {
        this.spinnerService.show();
        if (!this.status) {
            this.status = "Active";
        }
        this.userService.getcustomerList(this.FilPerpage, this.FilPage, this.serach, this.userobj._csrf, this.status).subscribe(list => {

            if (list.status) {
                this.actionListPerformed = true;
                this.actionViewPerformed = false;
                this.customerList = list.customers;
                this.currentPag = list.current;
                this.Tpager = list.pages;
                this.setPage(this.FilPage);
            }
            this.totalRecords = list.total;
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    /* Pagination of customer details */
    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getCustomerList();
    }

    /* Serach Event */
    sreach(event: any) {
        this.serach = event.target.value;
        this.FilPage = 1;
        this.getCustomerList();
    }

    viewData(userId) {
        this.spinnerService.show();
        this.userService.getCustomerDetailsById(userId).subscribe(done => {
            this.actionListPerformed = false;
            this.actionViewPerformed = true;
            this.imagecheck = done.profileimage;
            this.userobj.name = done.name
            done['profileimage'] = done.profileimage;
            this.customerdetails = done;
            this.readonlyTrue = done['short_name'];
            var country = csc.getCountryById(done.country);
            this.customerdetails['countryname'] = country.name;

            var state = csc.getStateById(done.state);
            this.customerdetails['statename'] = state.name;

            var city = csc.getCityById(done.city);
            this.customerdetails['cityname'] = city.name;
            if (this.customerdetails['dob']) {
                console.log(this.customerdetails['dob'], 'dob')
                const dob = this.customerdetails['dob'];
                const isValidDate = moment(dob, 'YYYY-MM-DD', true).isValid(); // Check if dob is a valid date
                if (isValidDate) {
                    this.customerdetails['dob'] = moment(dob, 'YYYY-MM-DD').toDate();
                } else {
                    this.customerdetails['dob'] = null; // Set it to null or an empty string if not valid
                }
            }
            this.customerdetails['country'] = done.country;
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    toggleReadOnly() {
        this.isReadOnly = !this.isReadOnly;
        this.showSaveRejectIcons = !this.showSaveRejectIcons; // Show icons when in edit mode
    }

    saveChanges(name) {
        this.isReadOnly = true;
        this.showSaveRejectIcons = false;
        this.userobj.name = name;
        this.userobj._id = this.customerid;
        this.userService.csrf().subscribe(data => {
            this.userobj['_csrf'] = data._csrf;
            const { notify } = defaults
            this.userService.updateCustomerName(this.userobj).subscribe(res => {
                if (res.status) this.notifSer.success('Sucess', res.message, notify)
                else this.notifSer.error('Error', res.message, notify)
            }, err => {
                this.notifSer.error(
                    'Error',
                    err.message,
                    notify
                )
            })
        })

    }

    rejectChanges() {
        this.isReadOnly = true;
        this.showSaveRejectIcons = false;
    }
    customerActivate(customer) {
        customer.status = 'Active';
        this.changeDetectorRef.detectChanges();
        this.spinnerService.show();
        this.userService.csrf().subscribe(user => {
            customer['_csrf'] = user._csrf;
            this.userService.setActiveLatest(customer).subscribe(done => {
                this.getCustomerList();
                this.spinnerService.hide();
                this.notifSer.success(
                    'Success',
                    done.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            })
        })

    }

    customerDeactivate(customer) {
        customer.status = 'Deactive';
        this.spinnerService.show();
        this.changeDetectorRef.detectChanges();
        this.userService.csrf().subscribe(user => {
            customer['_csrf'] = user._csrf;
            this.userService.setActiveLatest(customer).subscribe(done => {
                this.getCustomerList();
                this.spinnerService.hide();
                var sendobj = { userid: customer._id };
                this.notifSer.success(
                    'Success',
                    done.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error',
                    err.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )

            })
        })
    }
    customerAllowCredit(customer: any) {
        console.log(customer, 'customer')
        try {
            this.dialog.open(ConfirmationDialogComponent, {
                data: {
                    message: `Are you sure want to  credit limit?`,
                    buttonText: {
                        ok: 'Yes',
                        cancel: 'No'
                    }
                }
            }).afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    const { notify } = defaults
                    let data = {
                        _id: customer._id,
                        allowCredit: (customer.allowCredit === true) ? false : true
                    }
                    this.userService.csrf().subscribe(success => {
                        data['_csrf'] = success['_csrf'];
                        this.appCustomerService.updateUserForCreditLimit(data).subscribe(res => {
                            console.log(res);
                            if (res.status) this.notifSer.success('Sucess', res.message, notify)
                            else this.notifSer.error('Error', res.message, notify)
                            this.getCustomerList();
                        }, err => {
                            this.notifSer.error('Error', err.message, notify)
                        })
                    })
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
    delete(userId) {
        this.walletsService.getWalletsList(userId).subscribe(res => {
            if (res.length == 0) {
                this.spinnerService.show();
                this.userService.customerDelete(userId).subscribe(done => {
                    this.csrf();
                    this.spinnerService.hide();
                    this.notifSer.success(
                        'Success',
                        'Customer has been deleted',
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                }, (err) => {
                    this.spinnerService.hide();
                    this.notifSer.error(
                        'Error',
                        err.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                })
            } else {
                if (window.confirm('Are you sure want to delete this customer. Customer will loose data & money ?')) {
                    this.spinnerService.show();
                    this.userService.customerDelete(userId).subscribe(done => {
                        this.csrf();
                        this.spinnerService.hide();
                        this.notifSer.success(
                            'Success',
                            'Customer has been deleted',
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    }, (err) => {
                        this.spinnerService.hide();
                        this.notifSer.error(
                            'Error',
                            err.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    })
                }
            }
        })
    }
    walletsView(id) {
        this.walletActive = id;
    }

    round(val) {
        var digit = parseFloat(val).toFixed(5);
        return digit;
    }

    hasError(event) {
        if (event) {
            this.errorObj.phone = '';
            this.phonenumcheck = true;
        } else {
            this.errorObj.phone = 'Invalid Number';
        }
    }

    phonez(event) {
        console.log(event)
    }


    isEmptyObject(obj) {
        return (obj && (Object.keys(obj).length === 0));
    }

    onCountryChange(event) {
        this.userobj.phonecode = event.dialCode;
        this.userobj.country = event.name;

    }
    customerTfaDisable(custid: any) {
        this.tfaobj._id = custid
        this.userService.updateTfabyAdmin(this.tfaobj).subscribe(res => {
            this.getCustomerList();
            this.notifSer.success(
                'Success',
                res.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        }, (err) => {
            this.notifSer.error(
                'Error',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })

    }
    gettimezone() {
        this.userService.timezone().subscribe(res => {
            this.timezonelist = res;
        }, (err) => {
            console.log(err);
        });
    }
    updateUser(userdetail) {
        const { notify } = defaults
        if (userdetail.short_name === null || userdetail.short_name === "" || userdetail.short_name === undefined) {
            this.errorObj.short_name = 'Short Name is required';
            this.notifSer.error('Error', this.errorObj.short_name, notify)
            return false;
        }

        if (userdetail.ask_price_spread < -5) {
            this.errorObj.ask_price_spread = 'Ask Price Spread should greater than or equal -5';
            this.notifSer.error('Error', this.errorObj.ask_price_spread, notify)
            return false;
        }
        if (userdetail.bid_price_spread < -5) {
            this.errorObj.bid_price_spread = 'Bid Price Spread should greater than or equal -5';
            this.notifSer.error('Error', this.errorObj.bid_price_spread, notify)
            return false;
        }

        if (userdetail.referal_ask_price_spread < 0) {
            this.errorObj.referal_ask_price_spread = 'Referral Ask Price Spread should greater than or equal 0';
            this.notifSer.error('Error', this.errorObj.referal_ask_price_spread, notify)
            return false;
        }
        if (userdetail.referal_bid_price_spread < 0) {
            this.errorObj.referal_bid_price_spread = 'Referral Bid Price Spread should greater than or equal 0';
            this.notifSer.error('Error', this.errorObj.referal_bid_price_spread, notify)
            return false;
        }
        userdetail.phonecode = this.customerdetails['phonecode'];
        userdetail.country = this.customerdetails['country'];
        userdetail.short_name = this.customerdetails['short_name'];
        userdetail.referal_code = this.customerdetails['referal_code'];
        userdetail.is_api_client = this.customerdetails['is_api_client'];
        userdetail.use_level1_price = this.customerdetails['use_level1_price'];
        userdetail.email_notification = this.customerdetails['email_notification'];
        userdetail.mobile_notification = this.customerdetails['mobile_notification'];
        userdetail.telegram_chat_id = this.customerdetails['telegram_chat_id'];
        // Format the moment object in the desired format
        const formattedTimestamp = moment(this.customerdetails['dob']).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        if (this.customerdetails['dob']) {
            userdetail.dob = formattedTimestamp;
        }
        this.userService.csrf().subscribe((success) => {
            userdetail._csrf = success['_csrf'];
            const { notify } = defaults
            if (userdetail.phone != null && userdetail.phone != '' && userdetail.phone.length > 16) {
                this.notifSer.error(
                    'Error',
                    "Mobile number should not have more that 16 digits",
                    notify
                )
            }
            else {
                this.userService.updateUserbyAdmin(userdetail).subscribe((response) => {
                    if (response.status) {
                        this.notifSer.success(
                            'Success',
                            response.message,
                            notify
                        )
                        this.router.navigateByUrl('/customer');
                    } else if (response.message.short_name) {
                        this.notifSer.error(
                            'Error',
                            (response.message) ? response.message.short_name : "Something went wonrg",
                            notify
                        )
                    }
                    else {
                        this.notifSer.error(
                            'Error',
                            (response.message) ? response.message.phone : "Something went wonrg",
                            notify
                        )
                    }
                    this.errorObj = {
                        userid: '',
                        name: '',
                        short_name: '',
                        referal_code: '',
                        email: '',
                        is_api_client: '',
                        phone: '',
                        password: '',
                        passwordrepeat: '',
                        group: '',
                        gender: '',
                        confirmpassword: '',
                        phonecode: '',
                        eurbalance: '',
                        country: '',
                        address: '',
                        ask_price_spread: '',
                        bid_price_spread: '',
                        referal_ask_price_spread: '',
                        referal_bid_price_spread: ''
                    };

                }, (err) => {
                    this.errorObj = err.error.message;
                    this.notifSer.error(
                        'Error',
                        this.errorObj.is_api_client,
                        notify
                    )
                })
            }
        })
    }
    sort_by(field, reverse, primer) {
        var key = primer ?
            function (x) { return primer(x[field]) } :
            function (x) { return x[field] };

        reverse = [-1, 1][+!!reverse];

        return function (a, b) {
            return a = key(a), b = key(b), reverse * (+(a > b) - +(b > a));
        }
    }
    getCountry() {
        this.userService.country().subscribe(res => {
            var arr = res.sort(this.sort_by("phonecode", true, parseInt));
            var result = arr.reduce((unique, o) => {
                if (!unique.some(obj => obj.phonecode === o.phonecode)) {
                    unique.push(o);
                }
                return unique;
            }, []);
            this.phonecodelist = result;
        }, (err) => {
            console.log(err);
        });

        this.userService.country().subscribe(res => {
            this.countries = res;
            this.countries.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        }, (err) => {
            console.log(err);
        });
    }
    selectedCountry(data) {
        var req = {
            id: data.currentTarget.selectedIndex,
            _csrf: this.userobj._csrf
        }
        this.userService.getMobileCode(req).subscribe(res => {
            this.userobj.phonecode = res.phonecode;
            this.customerdetails['phonecode'] = res.phonecode
        }, (err) => {
            console.log(err);
        });
    }
    navigateCryptoTrans(walletsdetails) {
        var obj: any = {
            userid: walletsdetails.userid,
            currency: walletsdetails.currency,
            type: walletsdetails.type
        }
        localStorage.removeItem("setuserid");
        localStorage.setItem('setuserid', JSON.stringify(obj))
        if (!walletsdetails.walletid) {
            this.router.navigate(['/fiat/activity/'])
        } else {
            this.router.navigate(['/crypto/activity/'])
        }
    }
    navigateNagativeBalance(walletsdetails) {
        var obj: any = {
            userid: walletsdetails.userid,
            currency: walletsdetails.currency
        }
        localStorage.removeItem("setuserid");
        localStorage.setItem('setuserid', JSON.stringify(obj))

        this.router.navigate(['/negativebalance/'])

    }
    convertToCamelCaseWithSpaces(text: any) {
        if (!text) return '';

        return text
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char: any) => char.toUpperCase())
            .trim();
    }

}


// WEBPACK FOOTER //
// ./src/app/appcustomerlist/appcustomerlist.component.ts